import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { GRU_SAVING_INFO_DETAIL_QUERY } from "../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const { data, loading, error } = useQuery(GRU_SAVING_INFO_DETAIL_QUERY, {
    fetchPolicy: "network-only",
    variables: { id: match.params.id },
  });

  if (loading) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }
  if (error || !data || !data.AdminGruSavingInfoDetail) {
    return (
      <div className="alert alert-danger m-t-20">
        적립정보를 불러오지 못했습니다.
      </div>
    );
  }

  const {
    AdminGruSavingInfoDetail: {
      id,
      commonStatus,
      name,
      currency,
      amount,
      isLocationCheck,
      gruSavingCount,
      gruSavingAmount,
      store,
      createdAt,
      updatedAt,
    },
  } = data;

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      id={id}
      commonStatus={commonStatus}
      name={name}
      currency={currency}
      amount={amount}
      isLocationCheck={isLocationCheck}
      gruSavingCount={gruSavingCount}
      gruSavingAmount={gruSavingAmount}
      store={store}
      createdAt={createdAt}
      updatedAt={updatedAt}
    />
  );
});
